import { Component, OnInit, NgModule,Inject} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../../services/api.services';
import { parseDate } from '../../../../utils/dateUtils';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AgGridAngular } from 'ag-grid-angular';
import { CellClickedEvent, ColDef, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/Core/services/user.service';

// Interface for the 'User' object (if not already defined)
interface User {
  // Define the properties of the User object
  // Example:
  id: number;
  name: string;
  // ... Add other properties as needed
}


interface ResponseData {
  items: User[];
  pager: {
    total: number;
    per_page: number;
    current: number;
  };
}

@Component({
  selector: 'app-user-details-display',
  templateUrl: './user-details-display.component.html'
})
export class UserDetailsDisplayComponent implements OnInit {


  // Replace 'any' with the appropriate type for your API URL
  apiURL: any;
  searchQuery: string = '';
  rowData: any[]=[];
  currentPage: number = 1;

  columnDefs: ColDef[] = [
    { field: 'id' },
    { field: 'name' , 
    cellRenderer: function(params: ICellRendererParams){
      return '<a href="https://www.google.co.in" target="_blank">'+params.value+'</a>'
    }
  
    },
    { field: 'brand' },
    { field: 'notify' },
    { field: 'pioneer' },
    { field: 'verified_email' },
    { field: 'created' },
    { field: 'ayla_email' },
    { field: 'alexaenabled' },
    { field: 'logenabled' },
    { field: 'device_types' }
  ];



  public defaultColDef: ColDef ={
    sortable: true,
    filter: true,
    flex: 1,
    minWidth:25,
    resizable:true,
  //gridAutoRowHeight: true, // Set to true to make columns horizontal
    // floatingFilter:true,
  };

  constructor(
    private route: ActivatedRoute,
    @Inject(ApiService) private api: ApiService,
    private http: HttpClient,
    private userService:UserService,
    private router: Router
  ) {
    // ... Constructor logic
  }
  
  makeApiRequestWithToken() {
    // Set the bearer token value
    const bearerToken = 'aa6d654352a7c2feebb8309067fe133265e7f5e969a65e9bb0be73154bef18e3';
  
    // Set the request headers
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${bearerToken}`,

    }).set('content-type', 'application/json;charset=utf-8');
    // .set('Access-Control-Allow-Origin', '*');;
  
    //const url = `https://admin.dsservers.net/api/user?page=1&q=${this.searchQuery}`;
    // this.updateApiURL();
    // Make the API request with the headers
    this.http.get<ResponseData>(this.apiURL, { headers }).subscribe(
       (response) => {
        // Handle the API response
        this.rowData=response.items;
        console.log(response);
        
      },
       (error) => {
        // Handle the API error
        console.error(error);
      }
    );
  }
  
  onSearchClick(): void {
    // Call the API request with the updated search query
    
    this.makeApiRequestWithToken();
  }

  onGridReady(params: GridReadyEvent): void {
    this.userService.getUserData(this.currentPage, this.searchQuery).subscribe(
      (response:any) => {
        this.rowData = response.items;
        console.log(response);
      },
     
      (error) => {
        console.error('Error fetching user data:', 'Error fetching user data:', error);
      }
    
    );
  }
  
  
  
  // Example of consuming Grid Event
  onCellClicked( e: CellClickedEvent): void {
    console.log('cellClicked', e);
  }

  // // Example using Grid's API
  // clearSelection(): void {
  //   this.agGrid.api.deselectAll();
  // }

  // getData(): Observable<any>{
  //   return this.http.get<any>(this.apiURL);
  // }

  
  ngOnInit() {
    // this.getData().subscribe(data => {
    //   this.rowData = data;
    // });
    
   this.makeApiRequestWithToken();
  }
}
